module.exports = "https://ec-cstatic.akulaku.net/mall/growth-publish/_next/static/images/WhatsApp-4e3f538aefb39244f4bb22a1e1fd0021.png";